import { makeStyles, tokens, shorthands } from "@fluentui/react-components";

export const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    overflowX: "hidden",
    justifyContent: "space-between",
    backgroundColor: tokens.colorNeutralBackground1,
    ...shorthands.gap("6px"),

    "@media (min-width: 500px)": {
      backgroundColor: tokens.colorNeutralBackground2,
      marginTop: "20px",
      display: "flex",
      flexDirection: "column",
      maxHeight: "100%",
      width: "100%",
    },
  },
  addIcon: {
    width: "fit-content",
    justifyContent: "flex-end",
    ...shorthands.padding(0),
    color: tokens.colorBrandForeground1,
    minWidth: "unset",
    "&:hover": {
      backgroundColor: "inherit",
      color: tokens.colorBrandForeground1,
    },
  },
  header: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: tokens.colorNeutralBackground3,
    ...shorthands.padding("18px"),
    "@media (min-width: 500px)": {
      backgroundColor: tokens.colorNeutralBackground2,
    },
  },
  list: {
    display: "flex",
    flexDirection: "column",
    ...shorthands.padding("9px", "0px", "9px", "0px"),
    ...shorthands.gap("9px"),
    "@media (min-width: 500px)": {
      overflowY: "auto",
      overflowX: "hidden",
      flexGrow: 1,
      minHeight: 0,
      scrollbarGutter: "stable",
      "::-webkit-scrollbar": {
        width: "4px",
        height: "4px",
      },
      "::-webkit-scrollbar-thumb": {
        backgroundColor: "#888",
        ...shorthands.borderRadius("4px"),
      },
      "::-webkit-scrollbar-track": {
        backgroundColor: "#ccc",
        ...shorthands.borderRadius("4px"),
      },
      "::-webkit-scrollbar-thumb:hover": {
        backgroundColor: "#555",
      },
    },
  },
  sectionTitle: {
    color: tokens.colorPaletteMinkForeground2,
  },
  itemAmount: {
    fontWeight: tokens.fontWeightRegular,
    color: tokens.colorNeutralForeground3,
    alignSelf: "flex-start",
  },
  taxAmount: {
    fontWeight: tokens.fontWeightRegular,
    color: tokens.colorNeutralForeground3,
  },
  totalAmount: {
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralForeground1,
  },
});
